module.exports = __webpack_public_path__ + "static/media/Header 1.99a53ab7.svg";